import _ from 'lodash';

export default class User {
  constructor(data) {
    this.id = _.get(data, 'id', '');
    this.firstName = _.get(data, 'firstname', '');
    this.firstName = _.get(data, 'firstname', '');
    this.lastName = _.get(data, 'lastname', '');
    this.name = `${this.firstName} ${this.lastName}`;
    this.email = _.get(data, 'email', '');
    this.shopId = _.get(data, 'shopId', '');
  }
}
